<div
    *ngFor="let row of model(); let i = index"
    class="st-special-cost-row">
    <ng-template
        let-col
        let-j="index"
        ngFor
        [ngForOf]="columns()">
        @if (col.validation.toUpperCase() === 'TEXT' || col.validation.toUpperCase() === 'TIME' || col.validation.toUpperCase() === 'MOSDATETIME' || col.validation.toUpperCase() === 'DURATION') {
            <st-text-field-currency
                class="st-special-cost-row__cost"
                [disabled]="calculateEditable(i)"
                [label]="costColumnLabel()"
                [value]="getValue(i, j)"
                [required]="required() && i === 0 && !value()?.hasValues()"
                (changed)="valueChanged($event, i, j)" />
        } @else if (col.validation.toUpperCase() === 'COMBOBOX') {
            <st-combo-box
                class="st-special-cost-row__cost-type"
                [required]="required() && i === 0 && !value()?.hasValues()"
                [label]="costTypeColumnLabel()"
                [itemList]="col.list"
                [disabled]="disabled()"
                [value]="getValue(i, j)"
                (changed)="valueChanged($event, i, j)" />
        }
    </ng-template>
</div>
